import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import CustomContainer from '../../components/common/CustomContainer'
import { useNavigate } from 'react-router-dom'
import styles from "../../assets/styles/labtest.module.css"
import { useDownloadExcel } from 'react-export-table-to-excel';
import { getInventoryListApi, getMedicalRoomApi } from '../../utils/api/services'
import { toast } from 'react-toastify'
import moment from 'moment'
import InventoryTable from '../../components/inventory/InventoryTable'

const Inventory = () => {
    const [searchValue, setSearchValue] = useState('')
    const [filterValue, setFilterValue] = useState<FilterTypes>({
        fromDate: null,
        toDate: null
    })
    const [loading, setLoading] = useState(false)
    const [listData, setListData] = useState<InventoryListTypes[] | []>([]);
    const navigate = useNavigate();
    const tableRef = useRef<HTMLTableElement>(null);
    
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'inventory',
        sheet: 'inventory'
    })

    const handleDateChange = (value: Date | null, name: string) => {
        const momentValue = value !== null ? moment(value)?.format('DD-MM-YYYY') : null;
        setFilterValue({
            ...filterValue,
            [name]: momentValue
        })
    }
    const handleSearchValue = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value)
    }

    const fetchlistData = async (data?: { searchQuery?: string, fromDate?: Date | null, toDate: Date | null }) => {
        try {
            setLoading(true)
            const result = await getInventoryListApi(data);
            if (result?.success) {
                setLoading(false)
                setListData(result?.inventories)
            }
            else {
                setLoading(false)
                setListData([])
            }
        } catch (error: any) {
            setLoading(false)
            toast.error(error?.data?.errors || error?.message);
        }
    }

    useEffect(() => {
        if (searchValue) {
            const cleanUpFun = setTimeout(() => {
                fetchlistData({ searchQuery: searchValue, fromDate: filterValue?.fromDate, toDate: filterValue?.toDate })
            }, 1000);
            return () => clearInterval(cleanUpFun)
        }
        else {
            fetchlistData({ searchQuery: searchValue ? searchValue : undefined, fromDate: filterValue?.fromDate, toDate: filterValue?.toDate })
        }
    }, [searchValue, filterValue]);

    return (
        <CustomContainer>
            <div className='AllPageMain'>
                <div className='HeadAndButton'>
                    <h2>Inventory</h2>
                    <div className='flex items-center gap-6'>
                        <button className='fillButton' onClick={() => navigate('/inventory/add')}>New Entry +</button>
                        <button className='outLineBtn' onClick={onDownload}>Export Data</button>
                    </div>
                </div>
                <div className={styles.labTestMain}>
                    <InventoryTable
                        listData={listData}
                        loading={loading}
                        searchValue={searchValue}
                        ref={tableRef}
                        handleSearchValue={handleSearchValue}
                        filterValue={filterValue}
                        handleDateChange={handleDateChange}
                    />
                </div>
            </div>
        </CustomContainer>
    )
}

export default Inventory